<template>
  <div class="form-input-field">
    <label v-if="label" :for="name">{{ label }}</label>
    <input
      :type="inputType"
      :required="isRequired"
      :pattern="inputPattern"
      :name="name"
      class="form-control"
      :autocomplete="autocomplete"
      :placeholder="placeholder"
      ref="formControl"
      :autofocus="autofocus"
      @input="update"
      :value="value"
    >
    <slot></slot>
  </div>
</template>
<script>
import { baseInput } from "./baseInput.js";

export default {
  mixins: [baseInput]
};
</script>
